export const useAnalytics = () => {
  const gtm = useGtm();

  /**
   * Generic track event
   */
  const trackEvent = (event: string, properties: Record<string, any> = {}) => {
    if (gtm) {
      gtm.trackEvent({
        event,
        ...properties,
      });
    }
  };

  /**
   * Track CTA Clicks
   */
  const trackCtaClick = (text: string, location: string) => {
    trackEvent("cta_click", {
      cta_text: text,
      cta_location: location,
    });
  };

  /**
   * Track Appointment Modal Open
   */
  const trackAppointmentModalOpen = (url: string) => {
    trackEvent("appointment_modal_open", {
      booking_url: url,
    });
  };

  /**
   * Track Appointment Booked (from Cal.com postMessage)
   */
  const trackAppointmentBooked = (details: Record<string, any> = {}) => {
    trackEvent("appointment_booked", details);
  };

  /**
   * Track Navigation Clicks
   */
  const trackNavigationClick = (label: string, destination: string) => {
    trackEvent("nav_click", {
      nav_label: label,
      nav_destination: destination,
    });
  };

  /**
   * Track Section View (using Intersection Observer)
   */
  const trackSectionView = (sectionId: string) => {
    trackEvent("section_view", {
      section_id: sectionId,
    });
  };

  /**
   * Track Form Steps
   */
  const trackFormStep = (formId: string, step: number, stepName: string) => {
    trackEvent("form_step", {
      form_id: formId,
      step_number: step,
      step_name: stepName,
    });
  };

  return {
    trackEvent,
    trackCtaClick,
    trackAppointmentModalOpen,
    trackAppointmentBooked,
    trackNavigationClick,
    trackSectionView,
    trackFormStep,
  };
};
